import { LinkButton } from '@/components/Button';
import { Flex } from '@/components/Grid';
import { Tab, TabBar } from '@/components/TabBar';
import { useModal } from '@/hooks/useModal';
import { useAccount } from '@/resource/account';
import { type AdType } from '@/resource/ad';
import styles from './Nav.module.scss';

const overviewTypeOffers = 'market_offers';
const overviewTypeRequests = 'market_requests';

type Props = {
  adType: AdType;
};

export function Nav({ adType }: Props) {
  const account = useAccount();
  const modal = useModal();
  const adLabel = adType === 'offer' ? 'Aanbod' : 'Vraag';
  const overviewType = `market_${adType}s` as const;

  return (
    <div className={styles.Nav}>
      <TabBar>
        <Tab
          to={{ type: overviewTypeRequests }}
          active={overviewTypeRequests === overviewType}
        >
          Vraag
        </Tab>
        <Tab
          to={{ type: overviewTypeOffers }}
          active={overviewTypeOffers === overviewType}
        >
          Aanbod
        </Tab>
      </TabBar>

      <Flex dir="column">
        <LinkButton
          to={account.profile ? { type: `add_${adType}` } : { type: 'home' }}
          align="right"
          onClick={(e, refocus) => {
            if (!account.profile) {
              e.preventDefault();
              modal.open(
                {
                  type: 'login',
                  props: {
                    title: `Om een ${adLabel.toLowerCase()} te plaatsen moet je ingelogd zijn`,
                  },
                },
                refocus
              );
            }
          }}
        >
          Plaats {adLabel.toLowerCase()}
        </LinkButton>
      </Flex>
    </div>
  );
}
